import React, { FC } from 'react';
import { useTranslation, WidgetProps } from '@wix/yoshi-flow-editor';
import { CalendarSmall } from '@wix/wix-ui-icons-common/on-stage';

import { classes } from './Widget.st.css';

type Props = {
  isSpecEnabled: boolean;
  onlineOrderingUrl: string | null;
  isOnlineOrdering: boolean;
  deliveryStepState: 'open' | 'summary' | undefined;
  onChangeDateTimeClick?: () => Promise<void> | void;
};

const Widget: FC<WidgetProps<Props>> = ({
  isSpecEnabled,
  onlineOrderingUrl,
  isOnlineOrdering,
  deliveryStepState,
  onChangeDateTimeClick,
}) => {
  const { t } = useTranslation();

  if (
    !isSpecEnabled ||
    !isOnlineOrdering ||
    !onlineOrderingUrl ||
    deliveryStepState !== 'open'
  ) {
    return null;
  }

  return (
    <div className={classes.root}>
      <span className={classes.icon}>
        <CalendarSmall width={24} height={24} />
      </span>
      <a
        className={classes.link}
        href={onlineOrderingUrl}
        onClick={async (e) => {
          e.preventDefault();
          try {
            await onChangeDateTimeClick?.();
          } finally {
            window.location.assign(onlineOrderingUrl);
          }
        }}
      >
        {t('checkout-delivery-options.change-delivery-date-and-time')}
      </a>
    </div>
  );
};

export default Widget;
